class Slider {
  host: Element;
  slides: NodeListOf<HTMLElement>;
  slideContainer: HTMLElement | null;
  nextButton?: HTMLElement | null;
  prevButton?: HTMLElement | null;
  padding: number;
  isMobile: boolean;
  showNavigation: boolean;
  slideWidth: number;

  constructor(host: Element) {
    this.host = host;
    this.padding = 16;
    this.slides = this.host.querySelectorAll(".vs-slide");
    this.slideContainer = host.querySelector(".slide-container");
    this.nextButton = host.querySelector(".next");
    this.prevButton = host.querySelector(".previous");
    this.showNavigation = host.getAttribute("data-showNavigation") === "true";
    this.slideWidth = this.slides[0].offsetWidth + this.padding;
  }

  isAtEnd(): boolean {
    if (!this.slideContainer) return false;
    const tolerance = 5; // Small tolerance for rounding errors
    return this.slideContainer.scrollLeft + this.slideContainer.clientWidth >= 
           this.slideContainer.scrollWidth - tolerance;
  }

  isAtBeginning(): boolean {
    if (!this.slideContainer) return false;
    const tolerance = 5; // Small tolerance for rounding errors
    return this.slideContainer.scrollLeft <= tolerance;
  }

  scrollToBeginning() {
    this.slideContainer?.scrollTo({
      left: 0,
      behavior: "smooth",
    });
  }

  scrollToEnd() {
    if (!this.slideContainer) return;
    this.slideContainer.scrollTo({
      left: this.slideContainer.scrollWidth - this.slideContainer.clientWidth,
      behavior: "smooth",
    });
  }

  scrollNext() {
    if (!this.slideContainer) return;
    
    if (this.isAtEnd()) {
      // Already at the end, scroll back to beginning
      this.scrollToBeginning();
    } else {
      // Normal scroll
      this.slideContainer.scrollTo({
        left: this.slideContainer.scrollLeft + this.slideWidth,
        behavior: "smooth",
      });
    }
  }

  scrollPrev() {
    if (!this.slideContainer) return;
    
    if (this.isAtBeginning()) {
      // Already at the beginning, scroll to end
      this.scrollToEnd();
    } else {
      // Normal scroll
      this.slideContainer.scrollTo({
        left: this.slideContainer.scrollLeft - this.slideWidth,
        behavior: "smooth",
      });
    }
  }

  showNav() {
    this.nextButton?.addEventListener("click", () => {
      this.scrollNext();
    });
    
    this.prevButton?.addEventListener("click", () => {
      this.scrollPrev();
    });
  }

  init() {
    if (this.showNavigation) {
      this.showNav();
    }
  }
}

(() => {
  const elements = document.querySelectorAll(".vs-slider");
  if (elements) {
    elements.forEach((element) => {
      const slider = new Slider(element);
      slider.init();
    });
  }
})();